import React, { useMemo } from 'react';
import { TableBody, TableRow, TableCell } from '@mui/material';
import { CustomTable } from '../../components/table/CustomTable';

const DeviceMonitoringTable = ({
    data,
    monitoringData,
    limitList,
    canEdit = true,
    onEditableDataChange = () => { }
}) => {
    // limitList を Map 化
    const limitMap = useMemo(() => {
        const map = new Map();
        limitList.forEach(l => map.set(l.deviceId, l));
        return map;
    }, [limitList]);
    //-----------------------------------------------
    // Function - 上限値、下限値を判定
    //-----------------------------------------------
    const checkLimit = (value, limit) => {
        if (limit == null || value == null) return false;
        return value < limit.lowerLimit || value > limit.upperLimit;
    };
    //-----------------------------------------------
    // Function - 表示データに基準値判定を付与
    //-----------------------------------------------
    const dataWithStatus = useMemo(() => {
        if (!data) return [];

        return data.map(row => {
            const limit = limitMap.get(row.deviceId);

            return {
                ...row,
                isLimit: checkLimit(row.value, limit),
            };
        });

    }, [data, limitMap]);
    //-----------------------------------------------
    // Function - 過去データをまとめて、基準値判定を付与
    //-----------------------------------------------
    const monitoringGrouped = useMemo(() => {
        if (!Array.isArray(monitoringData)) {
            return {};
        }

        return monitoringData.reduce((grouped, row) => {

            const limit = limitMap.get(row.deviceId);

            const record = {
                ...row,
                isLimit:checkLimit(row.value, limit),
            };

            const key = row.deviceId;

            if (!grouped[key]) grouped[key] = [];
            grouped[key].push(record);

            return grouped;

        }, {});

    }, [monitoringData, limitMap]);

    //===============================================
    // Css
    //===============================================
    const inputCellStyle = {
        width: "120px",
        fontSize: "16px",
        textAlign: "center",
        padding: "2px",
        border: 'none',
        backgroundColor: '#FFF8C6',
    }
    const pastCellStyle = {
        textAlign: 'center',
        width: '80px',
        padding: '0px',
    }
    //===============================================
    // JSXのレンダー
    //===============================================
    return (
        <CustomTable
            aria-label="simple table"
            size="small"
            sx={{
                whiteSpace: 'nowrap',
                border: '1px solid #ccc',
                '& tr td': {
                    backgroundColor: '#fff' // 交互色の打ち消し
                }
            }}
        >
            <TableBody>
                {dataWithStatus?.map((item, index) => {
                    const pastList = monitoringGrouped[item.deviceId] || [];
                    return (
                        <TableRow key={index}>
                            <TableCell
                                style={{
                                    textAlign: 'center',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    width: '20%',
                                }}
                            >
                                {`冷蔵庫 ${item.deviceId}`}
                            </TableCell>
                            <TableCell style={{ fontSize: '16px' }}>温度</TableCell>

                            {pastList.map((p, i) => (
                                <TableCell key={`${item.deviceId}-past-${i}`} style={{
                                    ...pastCellStyle,
                                    color: p.isLimit ? "red" : "black",
                                }}>
                                    {p.value}
                                </TableCell>
                            ))}
                            {canEdit && ( // 条件付き表示
                                <TableCell style={{ textAlign: 'center', width: '80px', padding: '0px' }}>
                                    <input
                                        type="number"
                                        step="0.1"
                                        // 初期は0.0表示
                                        placeholder="0.0"
                                        value={
                                            item.value === 0 || item.value === "0"
                                                ? ""
                                                : item.value
                                        }
                                        onChange={(e) => onEditableDataChange(index, "value", e.target.value)}
                                        style={{
                                            ...inputCellStyle,
                                            color: item.isLimit ? "red" : "black",
                                        }}
                                    />
                                </TableCell>
                            )}
                        </TableRow>
                    );
                })}
            </TableBody>
        </CustomTable>
    );
};

export default DeviceMonitoringTable;